import { URL_LANGUAGES } from 'tradera/lang/constants.mjs';
import {
    selectEnvironment,
    selectFeatureSwitches
} from 'tradera/state/environment/selectors';
import { useAppSelector } from 'tradera/state/hooks';

const PATH_PREFIX = `(/(${URL_LANGUAGES.join('|')}))?`;

const shippingRegex = new RegExp(`${PATH_PREFIX}/frakt`);
const isShippingLink = (pathname: string) => shippingRegex.test(pathname);

const valuationRegex = new RegExp(`${PATH_PREFIX}/valuation`);
const isValuationLink = (pathname: string) => valuationRegex.test(pathname);

const messagingRegex = new RegExp(`${PATH_PREFIX}/messaging`);
const isMessagingLink = (pathname: string) => messagingRegex.test(pathname);

export const useTouchwebInNextWebSpaLink = (absoluteUrl: URL) => {
    const resolver = useTouchwebInNextWebSpaLinkResolver();
    return resolver(absoluteUrl);
};

export const useTouchwebInNextWebSpaLinkResolver = () => {
    const toggles = useAppSelector(selectFeatureSwitches) || {};
    const { isNativeAppContext } = useAppSelector(selectEnvironment);

    return (absoluteUrl: URL) => {
        const pathname = absoluteUrl?.pathname;
        if (isNativeAppContext) return false;

        if (isMessagingLink(pathname)) {
            return Boolean(toggles?.['next-web-messaging']);
        }

        if (isShippingLink(pathname)) {
            return Boolean(toggles?.['next-web-shipping']);
        }

        if (isValuationLink(pathname)) {
            return Boolean(toggles?.['next-web-valuation']);
        }
    };
};
